import React from 'react'
import { Form } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from 'react-select'
import Creatable from 'react-select/lib/Creatable'
import CreditCardInput from 'react-credit-card-input';
import { CardElement } from 'react-stripe-elements';
import classnames from 'classnames'
import {useDispatch, useSelector} from 'react-redux'


export const FormInput = React.forwardRef((props, ref) => {
  const { label, handleChange, desc, placeholder, type, value, options, disabled, className, labelClassName, isCreatable, warningDesc, readOnly } = props
  function getInputType(){
    switch(type){
      case "money":
        return MoneyInput
      case "number":
        return NumberInput
      case "date":
        return DateInput
      case "select":
        return SelectInput
      case "credit_card_stripe":
        return CreditCardInputStripe
      case "credit_card_paysimple":
        return CreditCardInputPaySimple
      default:
        return DefaultInput
    }
  }

  const Component = getInputType()

  return (
    <Form.Group className={className}>
      {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <div>
        <Component {...props} ref={ref}/>
      </div>
      {desc && <Form.Text className={classnames("pt-1", { "text-secondary": !warningDesc, "text-danger": warningDesc })}>{desc}</Form.Text>}
    </Form.Group>
  )
})

function MoneyInput(props){
  const { handleChange, value, disabled } = props

  return(
    <Form.Control 
      disabled={disabled} 
      value={value} 
      type="number"
      onChange={(e)=>handleChange(e.target.value)} 
      placeholder='Enter amount (ex. 20.00)'/>
  )
}

function NumberInput(props){
  const { handleChange, value, placeholder, disabled } = props

  return(
    <Form.Control 
      disabled={disabled} 
      value={value} 
      type="number"
      onChange={(e)=>handleChange(e.target.value)} 
      placeholder={placeholder}/>
  )
}

const CustomInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
  <input 
    className="form-control col-12"
    onClick={onClick} 
    value={value} 
    placeholder={placeholder}
    readOnly
    ref={ref}
  />
));

function DateInput(props){
  const { value, handleChange, placeholder, minDate, maxDate, readOnly } = props
  return(
    readOnly ? <DatePicker
      minDate={minDate}
      maxDate={maxDate}
      placeholderText={placeholder}
      className="form-control col-12"
      value={value}
      onChange={(value)=>handleChange(value)} 
      selected={value ? moment(value) : null}
      customInput={<CustomInput placeholder={placeholder} />}
      /> : 
      <DatePicker
      minDate={minDate}
      maxDate={maxDate}
      placeholderText={placeholder}
      className="form-control col-12"
      value={value}
      onChange={(value)=>handleChange(value)} 
      selected={value ? moment(value) : null} />
  )
}

function SelectInput(props){
  const { value, handleChange, placeholder, options, disabled, components, isCreatable } = props
  const Component = isCreatable ? Creatable : Select
  return(
    <Component
      isOptionDisabled={(option) => option.disabled === 'yes'}
      isDisabled={disabled}
      onChange={handleChange}
      options={options} 
      value={value}
      components={components}
      placeholder={placeholder}/>
  )
}

function CreditCardInputStripe(props) {
  return(
    <div className="form-control">
      <CardElement/>
    </div>
  )
}

const CreditCardInputPaySimple= React.forwardRef((props, ref) => {
  const [ errors, setErrors ] = React.useState(null)
  const { isDevelopment } = useSelector(state=>state.config)
  const [cardNumber, setCardNumber ] = React.useState('')
  const [cardExpiry, setCardExpiry ] = React.useState('')
  const [cardCvc, setCardCvc ] = React.useState('')
  const dispatch = useDispatch();
  const { resident, organization } = useSelector(state=> state);

  React.useImperativeHandle(ref, () => ({
    submit: () => createPaySimpleToken(),
  }));

  const createPaySimpleToken = async () => {
    const [ month, year ] = cardExpiry.split('/')
    const updatedCardNumber = cardNumber.replace(/ /g, '')
    const apiKey = await gatherApiKey();
    const shouldPointToSandbox = isDevelopment || window.location.href.includes('https://staging.onestepsoftware.net');
    const url = `https://${shouldPointToSandbox ? 'sandbox-api' : 'api'}.paysimple.com/payment_method/nonce`;
    $.ajax({
      url: url,
      type: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': apiKey
      },
      data: JSON.stringify({
        "key_entered_card": {
          "card_number": updatedCardNumber,
          "expiration_month": month.trim(),
          "expiration_year": `20${year ? year.trim() : ''}`,
          "cvv": cardCvc,
        },
        "end_user_info": {
          "host_url": window.location.href
        }
      }),
      success: (data) => {
        props.handlePaymentMethodSucceeded(data);
      },
      error: xhr => {
        const responseText = xhr.responseText || {};
        const responseErrors = $.parseJSON(responseText).errors;
        const errors = responseErrors ? responseErrors : ['Something went wrong'];
        const dispatchType = props.dispatchTypePaymentMethodFailed || 'FAILED_SUBMIT_NEW_PAYMENT_SOURCE';
        dispatch({ type: dispatchType, payload: errors })
      }
    })
  }

  const gatherApiKey = () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/reseller_client_token.json`,
        type: 'GET',
        success: (data) => {
          resolve(data.token);
        }
      })
    })
  }

  return(
    <div className="form-control">
      <CreditCardInput
        cardNumberInputProps={{ value: cardNumber, onChange: (e)=>setCardNumber(e.target.value) }}
        cardExpiryInputProps={{ value: cardExpiry, onChange: (e)=>setCardExpiry(e.target.value) }}
        cardCVCInputProps={{ value: cardCvc, onChange: (e) => setCardCvc(e.target.value) }}
        cardZipInputProps={{ value: 1, onChange: () =>{} }}
      />
      { errors && <div className="text-danger p-3">{ String(errors) }</div> }
    </div>
  )
  
})

function DefaultInput(props){
  const { handleChange, value, placeholder, disabled } = props

  return(
    <Form.Control disabled={disabled} value={value} onChange={(e)=>handleChange(e.target.value)} placeholder={`${placeholder ? placeholder : ''}`} />
  )
}


export default FormInput
